import React, { useState } from 'react';
import { Button, ButtonOwnProps, SvgIcon, Menu, MenuItem, Typography, SxProps, PopoverOrigin } from '@mui/material';
import { borderRadius, boxShadows, palette, spaces } from '../../../assets/styles/themes/tokens';

export interface ButtonOptions {
  id: string;
  icon: React.ElementType;
  text: string;
  onClick: () => void;
  isVisible: boolean;
}
interface ButtonWithMenuProps {
  variant: ButtonOwnProps['variant'];
  dataTestId: string;
  icon: React.ElementType;
  label: string;
  options: ButtonOptions[];
  color?: ButtonOwnProps['color'];
  buttonStyles?: SxProps;
  menuStyles?: SxProps;
  disabled?: boolean;
  menuProps?: {
    anchorOrigin?: PopoverOrigin;
    transformOrigin?: PopoverOrigin;
  }
}

const ButtonWithMenu: React.FC<ButtonWithMenuProps> = (props) => {
  const { 
    variant, 
    dataTestId, 
    icon, 
    label, 
    options, 
    buttonStyles,
    menuStyles,
    menuProps,
    disabled,
    color='primary' 
  } = props;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        id='basic-button'
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        variant={variant}
        size='large'
        color={color}
        key='add-material-button'
        data-testid={dataTestId}
        sx={{ ...buttonStyles }}
        disabled={disabled}
        startIcon={
          <SvgIcon 
            component={icon} 
            sx={{ stroke: variant === 'contained' ? palette.primary.contrastText : palette.text.primary }}
          />
        }
      >
        {label}
      </Button>
      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={{
          ...menuStyles,
          '& .MuiMenu-paper': {
            boxShadow: boxShadows.elevation8,
            borderRadius: borderRadius.xs,
            padding: `0 ${spaces.xs}`,
          }
        }}
        {...menuProps}
      >
        {options.map((option: any) => (
          option.isVisible && (
            <MenuItem 
              data-testid={option.id}
              key={option.id} 
              onClick={() => {
                option.onClick();
                handleClose();
              }}
              sx={{
                borderRadius: borderRadius.sm,
              }}
            >
              <SvgIcon component={option.icon} sx={{ fill: palette.text.primary, marginRight: spaces.md }}/>
              <Typography sx={{ fontWeight: 400, color: palette.text.primary }}>{option.text}</Typography>
            </MenuItem>
          )
        ))}
      </Menu>
    </>
  );
};

export default ButtonWithMenu;
